// Copyright (c) StrangeBee 2023

const PREFIX = 'th_local_storage_';

interface StorageOutput {
    getItem: <T>(key: string) => T | null;
    setItem: <T>(key: string, value: T) => void;
    removeItem: (key: string) => void;
}

export const Storage: StorageOutput = {
    getItem: (key) => {
        const result = localStorage.getItem(`${PREFIX}${key}`);
        return result ? JSON.parse(result) : null;
    },
    setItem: (key, value): void => {
        const valueString = JSON.stringify(value);
        localStorage.setItem(`${PREFIX}${key}`, valueString);
    },
    removeItem: (key): void => {
        localStorage.removeItem(`${PREFIX}${key}`);
    },
};
